import { useEffect, useRef } from "react";

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const InContentAd = () => {
  const adRef = useRef<HTMLDivElement>(null);
  const adInitialized = useRef(false); // ✅ prevent duplicate ads

  useEffect(() => {
    if (adInitialized.current) return;

    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        adInitialized.current = true;
      }
    } catch (e) {
      // AdSense initialization error - fail silently in production
    }
  }, []);

  return (
    <div
      ref={adRef}
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "20px 0",
        minHeight: "100px", // prevents layout shift
      }}
    >
      <ins
        className="adsbygoogle"
        style={{
          display: "inline-block",
          width: "320px",
          height: "100px",
        }}
        data-ad-client="ca-pub-1599853380737685"
        data-ad-slot="9468244794"
      ></ins>
    </div>
  );
};

export default InContentAd;
